import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [company, setCompany] = useState({ name: "The Smith International" });

  useEffect(() => {
    let alive = true;
    api
      .get("/auth/me")
      .then(({ data }) => alive && setUser(data))
      .catch(() => alive && setUser(false));
    api
      .get("/company")
      .then(({ data }) => alive && setCompany(data))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, company }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
